import React, { useState } from "react";
import "./style.css";
import { AiOutlineHome } from "react-icons/ai";
import { AiOutlineUser } from "react-icons/ai";
import { BiBook } from "react-icons/bi";
import { AiOutlineProject } from "react-icons/ai";
import { RiContactsFill } from "react-icons/ri";

const Nav = (props) => {

  const [activeNav, setActiveNav] = useState("#");

  return (
    <nav>
      <ul>
        <li>
          <a
            onClick={() => setActiveNav("#")}
            className={activeNav === "#" ? "active" : ""}
            href="#"
          >
            <AiOutlineHome />
          </a>
        </li>
        <li>
          <a
            onClick={() => setActiveNav("#about")}
            className={activeNav === "#about" ? "active" : ""}
            href="#about"
          >
            <AiOutlineUser />
          </a>
        </li>
        <li>
          <a  onClick={() => setActiveNav("#experience")}
            className={activeNav === "#experience" ? "active" : ""} href="#experience">
            <BiBook />
          </a>
        </li>
        <li>
          <a  onClick={() => setActiveNav("#projects")}
            className={activeNav === "#projects" ? "active" : ""} href="#projects">
            <AiOutlineProject />
          </a>
        </li>
        <li>
          <a onClick={() => setActiveNav("#footer")}
            className={activeNav === "#footer" ? "active" : ""} href="#footer">
            <RiContactsFill />
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Nav;
